import { render, staticRenderFns } from "./helpDetail.vue?vue&type=template&id=21f58c21&scoped=true&"
import script from "./helpDetail.vue?vue&type=script&lang=js&"
export * from "./helpDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f58c21",
  null
  
)

export default component.exports